import React from 'react';
import './dots-config-app.css';
import {Progress, ProgressProps} from './components/Progress';
import {ApplicationsFetch, DipsApplications, LoginFetch} from './components/Fetch';
import {ConfigTool} from './components/ConfigTool';
import { Headline } from './components/Headline';

type LoginProps = {
  username:string,
  password:string,
  setUsername:Function,
  setPassword:Function,
  onLogin:Function,
  onCancel:Function,
}

// Optional developer/verifier login. Gives access to unreleased applications and
// developer features. Not needed for ordinary use of the tool.
const Login = (props:LoginProps)=>{
  return <div>
    <Headline isDeveloper={false}/>
  <div className='ActionArea'>
    <table width="80%">
      <tr>
        <td></td><td align="left" style={{padding:8}}><div className="Hint">Developer / verifier login<br></br>(Only needed for unreleased applications and developer features)</div></td>
      </tr>
      <tr>
        <th><small>Username</small></th>
        <td><input value={props.username} onChange={(e)=>{props.setUsername(e.target.value)}}></input></td>
      </tr>
      <tr>
        <th><small>Password</small></th>
        <td><input value={props.password} type="password" onChange={(e)=>{props.setPassword(e.target.value)}}></input></td>
      </tr>
      <tr><td></td><td align="left" style={{padding:32}}>
        <div className='Button' onClick={()=>(props.username.length>0 && props.password.length > 0) ?  props.onLogin() : null}>Login</div>
        <div className='Button' onClick={()=>props.onCancel()}>Back</div></td></tr>
    </table>
  </div>
  </div>
}

enum AppState {
  loadApplications,
  login,
  loginFetch,
  online,
  error,
}

type State = 
  { status: AppState.loadApplications }
| { status: AppState.login }
| { status: AppState.loginFetch }
| { status: AppState.online, token: string, rights:string, applications:DipsApplications }
| { status: AppState.error, error: Error };


const DotsConfigApp:React.FC = () => {
  // Starts in open mode: fetch the released applications, no login required.
  const [state, setState] = React.useState<State>({status:AppState.loadApplications});
  const [username, setUsername] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [progress, setProgress] = React.useState<ProgressProps>();
  const onLogin = () => {
    setProgress({text:"Please wait", subtext:"Logging in"});
    setState({status:AppState.loginFetch})}
  const goOpen = () => {
    setProgress({text:"", subtext:""});
    setState({status:AppState.loadApplications});
  }
  const isDeveloper : boolean = state.status === AppState.online && (state.rights.includes("D") || state.rights.includes("V"));
  return (
    <div className="App">
      <header className="App-header">
        {state.status === AppState.loadApplications && <ApplicationsFetch submit={true}
                    onApplications={(applications:DipsApplications)=>{
                      setState({status:AppState.online, token:"", rights:"", applications});
                      setProgress({text:"", subtext:""})}}
                    onError={(e:string)=>setProgress({
                      text:"Failed to load applications", subtext:e,
                      dismiss:()=>goOpen()})
                  }/>}
        {state.status === AppState.login && <Login  
                    username={username} 
                    password={password} 
                    setUsername={setUsername}
                    setPassword={setPassword}
                    onLogin={onLogin}
                    onCancel={goOpen}/>}
        {state.status === AppState.loginFetch && <LoginFetch submit={state.status === AppState.loginFetch} 
                    username={username} 
                    password={password} 
                    onTokenRightsApps={(token:string, rights:string, applications:DipsApplications)=>{
                      setState({status:AppState.online, token, rights, applications}); 
                      setProgress({text:"", subtext:""})}} 
                    onError={(e:string)=>setProgress({
                      text:"Login failed", subtext:e, 
                      dismiss:()=>{
                        setState({status:AppState.login});
                        setProgress({text:"", subtext:""})
                      }})
                  }/>}
        {state.status === AppState.online && <ConfigTool token={state.token} rights={state.rights} applications={state.applications}
          setProgress={(t:string,s:string)=>setProgress({text:t, subtext:s, dismiss:()=>goOpen()})}/>}
        {state.status === AppState.online && !(progress && progress.text) && <center><small>
          {isDeveloper
            ? <span>Developer mode. <a href="#open" onClick={(e)=>{e.preventDefault(); goOpen();}}>Log out</a></span>
            : <span>Sensative developer or verifier? <a href="#login" onClick={(e)=>{e.preventDefault(); setState({status:AppState.login});}}>Log in</a> for unreleased applications</span>}
          </small></center>}
        { progress && progress.text && Progress(progress) }
      </header>
    </div>
  );
}

export default DotsConfigApp;
